import React, { useEffect, useState } from "react";
import { getGroupsHome } from "../../services/groupServices";
import { getSettings } from "../../services/settingsServices";
import { getAdherentsByGroup } from "../../services/dashboardServices";

const PlanningCours = () => {
  const [groupes, setGroupes] = useState([]);
  const [saisonActive, setSaisonActive] = useState("");
  const [settings, setSettings] = useState(null);
  const [joursUtilises, setJoursUtilises] = useState([]);

  useEffect(() => {
    const orderedWeekDays = [
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
      "Dimanche",
    ];

    const extractJoursFromGroupes = (groupes) => {
      const jours = new Set();
      groupes.forEach((g) => {
        for (let i = 1; i <= 6; i++) {
          const horaire = g[`horaire${i}`];
          if (horaire) {
            const [jour] = horaire.split(" ");
            if (jour) jours.add(jour);
          }
        }
      });

      return Array.from(jours).sort(
        (a, b) => orderedWeekDays.indexOf(a) - orderedWeekDays.indexOf(b)
      );
    };

    const fetchData = async () => {
      try {
        const settingsData = await getSettings();
        if (settingsData && settingsData[0]?.saison_active) {
          setSaisonActive(settingsData[0].saison_active);
          setSettings(settingsData[0]);
        }

        const groupsData = await getGroupsHome();
        const adherentsData = await getAdherentsByGroup();
        if (groupsData?.length > 0) {
          const groupesActifs = groupsData
            .filter((g) => g.is_active)
            .map((g) => {
              const match = adherentsData.find((a) => a.nom === g.nom);
              return {
                ...g,
                adherentCount: match?.adherentCount || 0,
              };
            });

          setGroupes(groupesActifs);
          const joursTrouves = extractJoursFromGroupes(groupesActifs);
          setJoursUtilises(joursTrouves);
        }
      } catch (error) {
        console.error("Erreur chargement planning", error);
      }
    };

    fetchData();
  }, []);

  const getCoursParJour = (jour) => {
    const result = [];
    groupes.forEach((groupe) => {
      for (let i = 1; i <= 6; i++) {
        const horaire = groupe[`horaire${i}`];
        if (horaire && horaire.startsWith(jour)) {
          const [_, plage] = horaire.split(" ");
          result.push({ ...groupe, horaire: plage });
        }
      }
    });

    return result.sort((a, b) => a.horaire.localeCompare(b.horaire));
  };

  return (
    <div className="p-6 bg-white dark:bg-slate-800 text-black dark:text-white font-montserrat">
      {/* En-tête avec logo + titre */}
      <div className="flex items-center justify-center gap-6 mb-10 flex-wrap">
        {settings?.logo_club && (
          <img
            src={settings.logo_club}
            alt="Logo Club"
            className="w-auto h-28 drop-shadow-md"
          />
        )}
        <div className="text-center">
          <h1 className="text-3xl lg:text-4xl font-extrabold uppercase tracking-wide">
            Planning des cours
          </h1>
          <h2 className="text-xl font-light mt-1">
            Saison {saisonActive}
          </h2>
        </div>
      </div>

      {/* Grille par jour */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {joursUtilises.map((jour) => (
          <div key={jour}>
            <h3 className="text-lg md:text-xl font-bold uppercase border-b border-gray-300 pb-2 mb-4">
              {jour}
            </h3>
            {getCoursParJour(jour).map((cours, idx) => (
              <div
                className={`relative rounded-md shadow-md text-sm mb-4 px-3 py-2 text-black ${
                  cours.color_groupe || "bg-gray-200"
                }`}
              >
                {/* Badge "Complet" si quota atteint */}
                {cours.quota_groupe > 0 &&
                  cours.adherentCount >= cours.quota_groupe && (
                    <span className="absolute bottom-1 right-1 bg-red-600 text-white text-[10px] px-2 py-0 rounded-full font-bold uppercase shadow">
                      Complet
                    </span>
                  )}

                <div className=" text-xs font-semibold uppercase tracking-wide bg-white bg-opacity-50 mb-2">
                  {cours.horaire}
                </div>
                <div className="text-base font-extrabold uppercase font-montserrat leading-snug">
                  {cours.nom}
                </div>
                <div className="text-sm mt-1">
                  {[cours.enseignant1, cours.enseignant2, cours.enseignant3]
                    .filter(Boolean)
                    .join(" & ")}
                </div>
                <div className="text-xs font-semibold mt-1">
                  {cours.annees_naissance}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlanningCours;
